import NoInf from "components/noInf";
import TableRow from "components/rows/tableRow";
import Image from "components/img";
import { useTranslation } from "react-i18next";

type IProps = {
  imgList: any;
};

export default function RoomImg({ imgList }: IProps) {
  const { t } = useTranslation();

  return (
    <>
      <table>
        <tbody>
          <TableRow title={t("row_ttl_rm_img")}>
            <ul className="img-wrap">
              {imgList.length === 0 && <NoInf keyTxt="txt_img" />}
              {imgList.length !== 0 &&
                imgList.map((img: any) => {
                  const imgUrl = img.resImgPhUrl || img.thumImgPhUrl;
                  return (
                    <li className="flex">
                      <Image
                        key={img.expsOrdV}
                        src={imgUrl}
                        alt={t("row_ttl_rm_img")}
                      />
                    </li>
                  );
                })}
            </ul>
          </TableRow>
        </tbody>
      </table>
    </>
  );
}
